import React from 'react';
import {Link} from 'react-router-dom';

export const Warehouse = () => {
  return (
    <div className="main custom-scroll dark-bg">
      <h1 style={{ textAlign: 'center', marginBottom: 10 }}>Welcome</h1>
      <h4 style={{ fontWeight: 400, textAlign: 'center', marginTop: 10 }}>
        Please Login to go to the Warehouse
      </h4>
      <div className="dark-card">
        <form>
          <div className="dark-card__wrapper">
            <div className="dc-heading">Login</div>
            <div className="dc-body">
              <div className="form-grouped">
                <label>Username</label>
                <input
                  type="text"
                  id="username"
                  className="form-element"
                  placeholder="Eg. John101"
                  required
                />
              </div>
              <div className="form-grouped">
                <label>Password</label>
                <input
                  type="password"
                  id="password"
                  className="form-element"
                  placeholder="xxxxxx"
                  required
                />
              </div>
              <div className="flexed">
              <button className="submit">Login</button>
              <Link to="" className="forgot-password">Forgot Password?</Link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
